import React, { useEffect, useState, useRef, useContext } from 'react'
import ReactModal from 'react-modal'
import { ReactComponent as CloseModalIcon } from '../../../assets/early/svg/CloseModalIcon.svg'
import { ReactComponent as SecutiryModalImage } from '../../../assets/early/svg/SecutiryModalImage.svg'

import { useTranslation } from 'react-i18next'
import { useUser } from '../../../auth'
import { SECURITY_MODAL_TITLE } from '../constants/Constants'

function SecretKeyModal({ modalVisible = false, setModalVisible = () => {}, callbackFunction = () => {}, callbackFunctionType = 'back' }) {
    const { user } = useUser()
    const [secret, setSecret] = useState('')
    const [error, setError] = useState(false)
    const { t } = useTranslation()
    const inputRef = useRef(null)

    useEffect(() => {
        if (modalVisible) {
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus()
                }
            }, 100)
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalVisible])

    const requestClose = () => {
        setModalVisible(false)
        setError(false)
        setSecret('')
    }

    const handleSecretKey = (e) => {
        setSecret(e.target.value)
        setError('')
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let _secret_key = JSON.parse(localStorage.getItem('secret_key') || '{}')
        console.log('🚀 ~ handleSubmit ~ _secret_key:', _secret_key)
        if (secret == _secret_key[user?.id]) {
            setModalVisible(false)
            callbackFunction()
        } else {
            setError(true)
        }
    }

    return (
        <ReactModal
            transparent
            isOpen={modalVisible}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={requestClose}
            className="noScroll"
            style={{
                overlay: {
                    backgroundColor: '#00000065',
                    zIndex: 0,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 654,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                    position: 'relative',
                },
            }}
        >
            <div className="absolute top-[35px] w-full flex justify-center items-center">
                <div
                    className="w-[60px] h-[60px] bg-[#5e639b] rounded-full cursor-pointer flex items-center justify-center z-[2] hover:bg-[#413f5e]"
                    onClick={() => requestClose()}
                >
                    <CloseModalIcon />
                </div>
            </div>
            <form onSubmit={handleSubmit} className="bg-[#fafaff] relative rounded-[10px] mt-[30px] p-[60px_40px_40px_40px] flex flex-col items-center">
                <p className="font-bold text-[30px] leading-[38px] text-center tracking-[-0.02em] mt-[10px] text-[#5e639b]">{t(SECURITY_MODAL_TITLE[callbackFunctionType])}</p>
                <SecutiryModalImage />

                <div className="mx-[70px] p-[40px] pb-[20px] rounded-[20px] bg-[#FFFFFF] w-full">
                    <p className="text-[#5E639B] text-[16px] leading-5 font-semibold">{t('secretKey')}</p>

                    <input
                        ref={inputRef}
                        className="w-full bg-transparent border-b border-[#9392AD] py-[20px] pb-[14px] text-[#5e639b] outline-none placeholder-[#9392AD]"
                        type="password"
                        placeholder={t('enterSecretKey')}
                        value={secret}
                        onChange={(e) => handleSecretKey(e)}
                        autoComplete="off"
                    />
                    <p className=" text-[16px] leading-5 font-semibold text-center mt-[10px] " style={{ color: error ? '#FC4C59' : 'transparent' }}>
                        {t('Wrong secret key')}
                    </p>
                </div>
                <div className=" w-full flex flex-row justify-center gap-[20px] mt-[65px]">
                    <button className="flex items-center justify-center w-[158px] h-[50px] rounded-full bg-[#ECEBF8] hover:bg-[#E0E0F0]" type="button" onClick={requestClose}>
                        <p className="text-[#5E639B] text-[18px] leading-[22.5px] font-semibold">{t('close')}</p>
                    </button>
                    <button
                        type="submit"
                        className="flex items-center justify-center w-[158px] h-[50px] rounded-full bg-deepPurple hover:bg-darkenPurple"
                        disabled={!secret?.length}
                    >
                        <p className="text-[#FFFFFF] text-[18px] leading-[22.5px] font-semibold">{t('Proceed')}</p>
                    </button>
                </div>
            </form>
        </ReactModal>
    )
}

export default SecretKeyModal
